import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import ScrollTopButton from "@/components/feature/ScrollTopButton";
import FaqAccordion from "@/components/feature/FaqAccordion";
import SectionHeading from "@/components/base/SectionHeading";
import Hero from "@/pages/home/components/Hero";
import CategoryStrip from "@/pages/home/components/CategoryStrip";
import HotPick from "@/pages/home/components/HotPick";
import MemeWall from "@/pages/home/components/MemeWall";
import ReplyWall from "@/pages/home/components/ReplyWall";
import VideoRail from "@/pages/home/components/VideoRail";
import VoicesSection from "@/pages/home/components/VoicesSection";
import ContactBanner from "@/pages/home/components/ContactBanner";
import usePageMeta from "@/hooks/usePageMeta";
import { faqs } from "@/mocks/faqs";
import { site } from "@/mocks/site";

export default function Home() {
  usePageMeta({
    title: "网爆吃瓜 - 表情包、段子、神回复与梗图聚集地",
    description:
      "网爆吃瓜是吃瓜娱乐二创聚集地，网爆吃瓜表情包、段子、神回复和梗图持续上新，网爆吃瓜群众评论与二创视频都在这里，边吃瓜边玩梗，快乐加倍。",
    keywords: "网爆吃瓜,网爆吃瓜表情包,网爆吃瓜段子,网爆吃瓜神回复,网爆吃瓜梗图,吃瓜群众评论,二创视频",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: site.brand,
        description: site.description,
        inLanguage: "zh-CN",
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: site.brand,
        description: site.description,
        email: site.email,
      },
      {
        "@context": "https://schema.org",
        "@type": "WebPage",
        name: "网爆吃瓜首页",
        description: site.description,
        inLanguage: "zh-CN",
      },
    ],
  });

  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader />
      <main>
        <Hero />

        <section id="channels" className="container-page py-14 md:py-20">
          <SectionHeading
            eyebrow="Content Channels"
            title="五大内容频道，想看哪口瓜都行"
            desc="表情包、段子、神回复、梗图与二创视频分类整理，每类都标注了适用场景，点进去就能直接存图、转发。"
          />
          <CategoryStrip />
        </section>

        <section id="hot" className="bg-background-100/70">
          <div className="container-page py-14 md:py-20">
            <SectionHeading
              eyebrow="Hot Pick"
              title="这几条今天被转爆了"
              desc="按点赞与转发速度排出来的热门内容，排在前面的一般都在群里出现过好几轮了。"
              actionLabel="看全部梗图"
              actionPath="/gengtu"
            />
            <HotPick />
          </div>
        </section>

        <section id="memes" className="container-page py-14 md:py-20">
          <SectionHeading
            eyebrow="Meme Wall"
            title="梗图墙：一张图说完整句话"
            desc="生活里那些说不清的瞬间，交给梗图来表达。适合收藏之后慢慢发。"
            actionLabel="进入梗图频道"
            actionPath="/gengtu"
          />
          <MemeWall />
        </section>

        <section id="replies" className="bg-secondary-50">
          <div className="container-page py-14 md:py-20">
            <SectionHeading
              eyebrow="Epic Replies"
              title="神回复精选：评论区才是主角"
              desc="被老板问迟到、被亲戚催婚、被客服绕圈子，总有人能用一句话把场子接住。"
              actionLabel="更多神回复"
              actionPath="/shenhuifu"
            />
            <ReplyWall />
          </div>
        </section>

        <section id="videos" className="container-page py-14 md:py-20">
          <SectionHeading
            eyebrow="Fan-made Videos"
            title="二创视频：脑洞重新剪一遍"
            desc="方言配音、名场面混剪、评论区神回复配音，短平快，随时开刷。"
            actionLabel="进入视频频道"
            actionPath="/shipin"
          />
          <VideoRail />
        </section>

        <section id="voices" className="bg-background-100/70">
          <div className="container-page py-14 md:py-20">
            <SectionHeading
              eyebrow="Voices"
              title="吃瓜群众怎么说"
              desc="来自长期蹲守的网友与二创投稿者的真实反馈，也是我们持续更新的底气。"
            />
            <VoicesSection />
          </div>
        </section>

        <section id="faq" className="container-page py-14 md:py-20">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
            <div className="lg:col-span-4">
              <SectionHeading
                eyebrow="FAQ"
                title="常见问题"
                desc="关于内容使用、更新节奏与投稿方式，这里先回答一遍。还有其他疑问可以直接发邮件给我们。"
              />
            </div>
            <div className="lg:col-span-8">
              <FaqAccordion items={faqs.slice(0, 5)} />
            </div>
          </div>
        </section>

        <section id="contact" className="container-page pb-14 md:pb-20">
          <ContactBanner />
        </section>
      </main>
      <SiteFooter />
      <ScrollTopButton />
    </div>
  );
}